const fetchShowroomApi = async (url, method = "GET", body) => {
  const API_URL = "https://api.dressthepopulation.com";

  let headers = {
    "shopify-customer-id": window.customerID
  }

  if (body) {
    headers = {
      "Content-Type": "application/json",
      "shopify-customer-id": window.customerID
    }
  }

  const request = await fetch(`${API_URL}${url}`, {
    method: method,
    headers: headers,
    body: body || null
  })

  if (request.ok) {
    const contentType = request.headers.get("Content-Type");

    if (contentType && contentType.includes("application/json")) {
      return await request.json();
    } else {
      const responseText = await request.text();
      return responseText === "OK" ? true : responseText;
    }
  }
}

export default fetchShowroomApi;
